import React from 'react';
import Layout from '../layout';
import {
  GeneralPageContainer,
  PrivacyPolicy,
  PrivacyPolicyContent,
} from '../components/StyledComponents';
import messages from '../i18n/en';

class IndexPage extends React.PureComponent<any, any> {
  handleFormState = (value: boolean) => {
    this.setState({ formFilled: value });
  };

  public render() {
    return (
      <Layout
        title={`Esper Privacy Policy`}
        messages={messages}
        keywords={`Privacy policy`}
        description={`Privacy Policy for the Esper website and device management app, as well as all other Esper sites, networks, apps and services.`}
        className="first-page"
        location={this.props.location}
      >
        <GeneralPageContainer>
          <PrivacyPolicy> Privacy Policy </PrivacyPolicy>
        </GeneralPageContainer>
        <PrivacyPolicyContent>
          <p>
            <span>
              <strong>Esper Privacy Policy</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              This Privacy Policy (&ldquo;Policy&rdquo;) describes the manner in
              which Shoonya Enterprises Inc., with its registered office at 3600
              136th Pl SE # 220, Bellevue, WA 98006 (&ldquo;Esper&rdquo;,
              &ldquo;we,&rdquo; or &ldquo;us&rdquo;) our website at{' '}
              <a href="https://www.esper.io">
                <span className="s2">www.esper.io</span>
              </a>{' '}
              (the &ldquo;Site&rdquo;), and our mobile Application, as well as
              all related websites, networks, applications, and other services
              provided by us and on which a link to this Policy is displayed
              (collectively, together with the Site, and the mobile Application
              our &ldquo;Service&rdquo;), gather information from you on the
              Service, how we use and disclose such information, and the steps
              we take to protect such information.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Information we Collect</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>User-provided Information</strong>{' '}
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              When you use the Service, we may collect information about you,
              including your name, first name and last name, email address,
              mailing address, mobile phone number, phone number, your date of
              birth, geographic area, or preferences, and we may link this
              information with other information about you. You may provide us
              with information in various ways on the Service. For example, you
              provide us with information when you register for an account, use
              the service, send us customer service-related requests, or through
              cookies.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Cookies and Automatically Collected Information</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              When you use the Service, we may send one or more cookies &ndash;
              small text files containing a string of alphanumeric characters
              &ndash; to your device.
              <span>&nbsp; </span>We may use session cookies, preference cookies
              and security cookies. Please note that if you delete, or choose
              not to accept, cookies from the Service, you may not be able to
              utilize the features of the Service to their fullest
              potential.&nbsp;
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              We may use third party cookies on our Service as well.
              <span>&nbsp; </span>For instance, we may use Google Analytics to
              collect and process certain analytics data.
              <span>&nbsp; </span>Google Analytics is a web analytics service
              offered by Google that tracks and reports website traffic. Google
              uses the data collected to track and monitor the use of our
              Service. This data is shared with other Google services. Google
              may use the collected data to contextualize and personalize the
              ads of its own advertising network. Google provides some
              additional privacy options described at{' '}
              <a href="https://policies.google.com/technologies/partner-sites">
                <span className="s2">
                  https://policies.google.com/technologies/partner-sites
                </span>
              </a>{' '}
              regarding Google Analytics cookies.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              Similarly, we use Crashlytics, a software development kit for
              crash reporting, application logging, online review and
              statistical analysis of application logs.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              We may also automatically record certain information from your
              device by using various types of technology, including &ldquo;web
              beacons.&rdquo; This automatically collected information may
              include your IP address or other device address or ID, web browser
              and/or device type, the web pages or sites that you visit just
              before or just after you use the Service, the pages or other
              content you view or otherwise interact with on the Service, and
              the dates and times that you visit, access, or use the Service. We
              also may use these technologies to collect information regarding
              your interaction with email messages, such as whether you opened,
              clicked on, or forwarded a message. This information is gathered
              from all users and may be connected with other information about
              you.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Log files</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              Esper follows a standard procedure of using log files. These files
              log visitors when they visit websites. All hosting companies do
              this and a part of hosting services analytics. The information
              collected by log files include internet protocol (IP) addresses,
              browser type, Internet Service Provider (ISP), date and time
              stamp, referring/exit pages, and possibly the number of clicks.
              These are not linked to any information that is personally
              identifiable. The purpose of the information is for analyzing
              trends, administering the site, tracking users' movement on the
              website, and gathering demographic information.{' '}
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Access to Call Logs And SMS Data</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              In order to provide call and SMS-blocking related features, Esper
              applications and services will, from time-to-time access incoming
              and outgoing call information on mobile devices running said
              services. This will extend to SMS information, if SMS-blocking
              features have been enabled.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Third Party Web Beacons and Third-Party Buttons</strong>{' '}
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              We may display third-party content on the Service, including
              third-party advertising.<span>&nbsp; </span>
              Third-party content may use cookies, web beacons, or other
              mechanisms for obtaining data in connection with your viewing of
              the third-party content on the Service. Additionally, we may
              implement third party buttons (such as &ldquo;like&rdquo; or
              &ldquo;share&rdquo; buttons) that may function as web beacons even
              when you do not interact with the button. Information collected
              through third-party web beacons and buttons is collected directly
              by these third parties, not by Esper. Information collected by a
              third party in this manner is subject to that third party&rsquo;s
              own data collection, use, and disclosure policies.{' '}
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Information from Other Sources</strong>{' '}
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              We may obtain information about you from third parties and sources
              other than the Service, such as our partners and advertisers.{' '}
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>How We Use the Information We Collect</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              We use information we collect on / through the Service in a
              variety of ways in providing the Service and operating our
              business, including the following:&nbsp;
            </span>
          </p>
          <p>&nbsp;</p>
          <ol>
            <li>
              <span>
                We use the information that we collect on the Service to
                operate, maintain, enhance and provide all features of the
                Service, to provide services and information that you request,
                and to respond to comments and questions and otherwise to
                provide support to users.{' '}
              </span>
            </li>
            <li>
              <span>
                We use the information that we collect on the Service to
                understand and analyze the usage trends and preferences of our
                users, to improve the Service, and to develop new products,
                services, features, and functionality.{' '}
              </span>
            </li>
            <li>
              <span>
                We may use your email address or other information we collect to
                contact you for administrative purposes such as customer service
                or to send communications, including updates relating to
                products and services offered by us and by third parties and you
                hereby consent to receiving such communications by agreeing to
                these terms.{' '}
              </span>
            </li>
            <li>
              <span>
                We may use cookies and automatically collected information to:
                <span>&nbsp; </span>(i) personalize our Service, such as
                remembering information about you so that you will not have to
                re-enter it during your visit or the next time you visit the
                Service; (ii) provide customized advertisements, content, and
                information; (iii) monitor and analyze the effectiveness of the
                Service and third-party marketing activities; (iv) monitor
                aggregate site usage metrics such as total number of users,
                features used, and pages viewed; and (v) track your
                interactions, submissions, status or other activities on the
                Service.
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Disclosure of Information</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              Except as described in this Policy, we will not disclose
              information about you that we collect on the Service to
              third-parties without your consent. We may disclose information to
              third parties if you consent to us doing so, as well as in the
              following circumstances:
            </span>

            <p>&nbsp;</p>
          </p>
          <ol>
            <li>
              <span>
                Any information that you voluntarily choose to include in a
                publicly accessible area of the Service will be available to
                anyone who has access to that content, including other users.{' '}
              </span>
            </li>
            <li>
              <span>
                We may work with third-party service providers to provide
                various services. These third-party service providers may have
                access to or process information about you as part of providing
                those services for us. Generally, we limit the information
                provided to these service providers to that which is reasonably
                necessary for them to perform their functions, and we require
                them to agree to maintain the confidentiality of such
                information.
              </span>
            </li>
            <li>
              <span>
                We may disclose information about you if required to do so by
                law or in the good-faith belief that such action is necessary to
                comply with state and federal/central laws, in response to a
                court order, judicial or other government subpoena or warrant,
                or to otherwise cooperate with law enforcement or other
                governmental agencies.{' '}
              </span>
            </li>
            <li>
              <span>
                We also reserve the right to disclose information about you that
                we believe, in good faith, is appropriate or necessary to (i)
                take precautions against liability, (ii) protect ourselves or
                others from fraudulent, abusive, or unlawful uses or activity,
                (iii) investigate and defend ourselves against any third-party
                claims or allegations, (iv) protect the security or integrity of
                the Service and any facilities or equipment used to make the
                Service available, or (v) protect our property or other legal
                rights (including, but not limited to, enforcement of our
                agreements), or the rights, property, or safety of others.
              </span>
            </li>
            <li>
              <span>
                Information about our users may be disclosed and otherwise
                transferred to an acquirer, successor, or assignee as part of
                any merger, acquisition, debt financing, sale of assets, or
                similar transaction, or in the event of any insolvency,
                bankruptcy, or receivership in which information is transferred
                to one or more third parties as one of our business assets.
              </span>
            </li>
            <li>
              <span>
                We may make certain aggregated, automatically-collected, or
                otherwise non-personal information available to third parties
                for various purposes, including (i) compliance with various
                reporting obligations; (ii) for business or marketing purposes;
                or (iii) to assist such parties in understanding our
                users&rsquo; interests, habits, and usage patterns for certain
                programs, content, services, advertisements, promotions, and/or
                functionality available through the Service.
              </span>
            </li>
          </ol>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Third-Party Services</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              The Service may contain features or links to websites and services
              provided by third-parties. Any information you provide on
              third-party sites or services is provided directly to the
              operators of such services and is subject to those
              operators&rsquo; policies, if any, governing privacy and security,
              even if accessed through the Service. We are not responsible for
              the content or privacy and security practices and policies of
              third-party sites or services to which links or access are
              provided through the Service. We encourage you to learn about
              third parties&rsquo; privacy and security policies before
              providing them with information.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Children&rsquo;s Privacy</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              Protecting the privacy of young children is important. We do not
              knowingly collect personally identifiable information from anyone
              under the age of 18. If you are a parent or guardian and you are
              aware that your Children has provided us with Personal Data,
              please contact us. If we become aware that we have collected
              Personal Data from children without verification of parental
              consent, we take steps to remove that information from our
              servers.{' '}
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Data Security</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              We use certain physical, managerial, and technical safeguards that
              are designed to improve the integrity and security of information
              that we collect and maintain as required by applicable law. Please
              be aware that no security measures are perfect or impenetrable.
              <span>&nbsp; </span>We cannot and do not guarantee that
              information about you will not be accessed, viewed, disclosed,
              altered, or destroyed by breach of any of our physical, technical,
              or managerial safeguards.&nbsp;
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Data Transfer</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              Your information, including Personal Data, may be transferred to
              and maintained on computers located outside of your state,
              province, country or other governmental jurisdiction where the
              data protection laws may differ than those from your jurisdiction
              operating the Service. By providing any information, including
              personal information, on or to the Service, you consent to such
              transfer, storage, and processing.{' '}
            </span>
          </p>
          <p>
            <span>
              If you are located outside United States and choose to provide
              information to us, please note that we may transfer the data,
              including Personal Data, to United States and process it there.{' '}
            </span>
          </p>
          <p>
            <span>
              Your consent to this Privacy Policy followed by your submission of
              such information represents your agreement to that transfer.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Changes and Updates to this Policy</strong>{' '}
            </span>
          </p>
          <p>
            <span>
              Please revisit this page periodically to stay aware of any changes
              to this Policy, which we may update from time to time. If we
              modify this Policy, we will make it available through the Service,
              and indicate the date of the latest revision. In the event that
              the modifications materially alter your rights or obligations
              hereunder, we will use reasonable efforts to notify you of the
              change. For example, we may send a message to your email address,
              if we have one on file, or generate a pop-up or similar
              notification when you access the Service for the first time after
              such material changes are made. Your continued use of the Service
              after the revised Policy has become effective indicates that you
              have read, understood and agreed to the current version of this
              Policy.
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>Your California Privacy Rights</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              Residents of California have the right to request a disclosure
              describing what types of personal information we have shared with
              third parties for their direct marketing purposes, and with whom
              we have shared it, during the preceding calendar year. You may
              request a copy of that disclosure by contacting us at{' '}
              <a href="mailto:partner@esper.io">
                <span className="s4">partner@esper.io</span>
              </a>
              .{' '}
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <span>
              <strong>How to Contact Us</strong>
            </span>
          </p>
          <p>&nbsp;</p>
          <p>
            <span>
              Please contact us with any questions or comments about this
              Policy, information we have collected or otherwise obtained about
              you, our use and disclosure practices, or your consent choices by
              email at{' '}
              <a href="mailto:partner@esper.io">
                <span className="s4">partner@esper.io</span>
              </a>
              .
            </span>
          </p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>
            <strong>Esper Enterprises Inc.</strong>
          </p>
          <p>
            <strong>3600 136th Pl SE # 220, Bellevue, WA 98006</strong>
          </p>
        </PrivacyPolicyContent>
      </Layout>
    );
  }
}

export default IndexPage;
